import React from 'react'
import ReactECharts from 'echarts-for-react'
import * as echarts from 'echarts'
import { useTranslation } from 'react-i18next'
import { useZtSubsetDataContext } from '../context'
import DataSkeleton from '../dataSkeleton'
import { formatEmpty } from '../utils'

echarts.registerTheme('theme_jekka', {
	backgroundColor: '#fff'
})

const ChartSeven: React.FC = () => {
	const { t } = useTranslation()
	const { dataList, infoData, chartLoading } = useZtSubsetDataContext()

	const optionList = {
		tooltip: {
			trigger: 'axis',
			confine: true,
			formatter: (params: any) => {
				if (!params || params.length === 0) return ''
				const lines: string[] = []
				lines.push(
					`<div style="margin-bottom:8px;font-weight:bold;">${t(
						'c_a_outbound_call_effective_quantity'
					)}</div>`
				)
				params.forEach((item: any) => {
					const value = item.data ?? 0
					let labelText = ''
					if (item.seriesName == '重派数量') {
						labelText = t('重派数量')
					} else if (item.seriesName == '退回数量') {
						labelText = t('退回数量')
					}
					lines.push(`
                <div style="margin-bottom:6px; display:flex; align-items:center;">
                    <span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:${item.color};margin-right:6px;"></span>
                    <span>${labelText}：</span>
                    <span style="font-weight:bold;">${value}</span>
                </div>
            `)
				})
				return lines.join('')
			}
		},
		legend: null,
		grid: {
			left: 10,
			right: 10,
			bottom: 12,
			containLabel: true
		},

		xAxis: {
			type: 'category',
			data: dataList?.date // MM.DD
		},
		yAxis: { type: 'value' },

		series: [
			/** 效接通量/重派数量 */
			{
				type: 'bar',
				name: '重派数量',
				data: dataList?.connection_redispatch_count?.map((item: any) => item),

				itemStyle: {
					color: '#ffb72b'
				},
				label: {
					show: dataList?.connection_redispatch_count?.length < 18,
					color: '#fff',
					formatter: (params: any) => formatEmpty(params.value)
				},
				stack: 'resolve',
				barWidth: dataList?.connection_redispatch_count?.length < 10 ? 36 : 'auto'
			},
			/** 效接通量/退回数量 */
			{
				type: 'bar',
				name: '退回数量',
				data: dataList?.connection_return_count?.map((item: any) => item),
				label: {
					show: dataList?.connection_return_count?.length < 18,
					formatter: (params: any) => formatEmpty(params.value)
				},
				stack: 'resolve',
				barWidth: dataList?.connection_return_count?.length < 10 ? 36 : 'auto',
				itemStyle: { color: '#6CE565', borderRadius: [8, 8, 0, 0] }
			}
		]
	}

	return (
		<div className="bg-white rounded-lg overflow-hidden px-4 w-[49.5%]">
			<div className="mt-[18px]">
				<div className="text-[14px] font-medium mb-[12px]">
					{t('c_a_outbound_call_effective_quantity')}
				</div>
				<div className="text-[14px] mb-[8px]">{t('c_a_outbound_call_effective_quantity_tips')}</div>
				<div className="text-[18px] font-medium flex items-center">
					<DataSkeleton value={infoData?.total?.connection_count} />
				</div>
			</div>

			<ReactECharts theme="theme_jekka" option={optionList} showLoading={chartLoading} />
		</div>
	)
}

export default ChartSeven
